module.exports = __webpack_public_path__ + "media/images/ic-index-shipping-3deedb05b31c96b68328dc27b609aeb8.svg";